"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameLiveState = void 0;
var GameLiveState;
(function (GameLiveState) {
    GameLiveState[GameLiveState["NotStarted"] = 0] = "NotStarted";
    GameLiveState[GameLiveState["Live"] = 1] = "Live";
    GameLiveState[GameLiveState["Suspended"] = 2] = "Suspended";
    GameLiveState[GameLiveState["Ended"] = 3] = "Ended";
    GameLiveState[GameLiveState["Closed"] = 4] = "Closed";
    GameLiveState[GameLiveState["Cancelled"] = 5] = "Cancelled";
    GameLiveState[GameLiveState["Abandoned"] = 6] = "Abandoned";
    GameLiveState[GameLiveState["Delayed"] = 7] = "Delayed";
    GameLiveState[GameLiveState["Unknown"] = 8] = "Unknown";
    GameLiveState[GameLiveState["Postponed"] = 9] = "Postponed";
    GameLiveState[GameLiveState["Interrupted"] = 10] = "Interrupted";
    GameLiveState[GameLiveState["AboutToStart"] = 11] = "AboutToStart";
})(GameLiveState = exports.GameLiveState || (exports.GameLiveState = {}));
